<template>
  <p>
    {{ textDisplay }}
  </p>
</template>

<script>
export default {
  name: 'TextTransition',
  props: {
    content: String,
    idName: String
  },
  data(){
    return {
      textDisplay: '',
      element: null,
      closeTimeout: null
    }
  },
  watch: {
    content() {
      this.toggle()
    },
  },
  methods: {
    toggle(){
      if(this.closeTimeout){
        clearTimeout(this.closeTimeout)
      }

      this.element.style.clipPath = 'polygon(0 100%, 100% 100%, 100% 100%, 0% 100%)'

      this.closeTimeout = setTimeout(() => {
        this.textDisplay = this.content
        this.element.style.clipPath = 'polygon(0 0, 100% 0, 100% 100%, 0% 100%)'
      }, 300)
    }
  },
  mounted(){
    this.element = document.getElementById(this.idName)
    this.toggle()
  }
}
</script>